import SectionHeading from './SectionHeading';
import { useInView } from '../hooks/useInView';
import { education } from '../data/resume';

export default function Education() {
  const [ref, isVisible] = useInView();

  return (
    <section id="education" className="section" ref={ref}>
      <div className={`reveal ${isVisible ? 'reveal--visible' : ''}`}>
        <SectionHeading number="04" title="Education" />

        <div className="education-grid">
          {education.map((item) => (
            <article key={item.institution} className="education-card">
              <time className="education-period">{item.period}</time>
              <h3 className="education-degree">{item.degree}</h3>
              <p className="education-institution">{item.institution}</p>
              <p className="education-detail">{item.detail}</p>
              {item.coursework && (
                <p className="education-coursework">
                  <span className="education-coursework-label">Relevant Coursework: </span>
                  {item.coursework}
                </p>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
